<div class="col-12 col-lg-9 mx-auto text-center">
   <div class="sec-title">
      <h2 class="title mrgn-b-2">{{contentHeading.title}}</h2>
   </div>
   <div class="sec-content mb-5">
      <p>{{contentHeading.content}}</p>
   </div>
</div>
